import { KolumnaEwidencjiFiltrowanie } from "./kolumnaEwidencjiFiltrowanie";

export class PobierzEwidencjeFiltry {
    kolumnyFiltrowania: Array<KolumnaEwidencjiFiltrowanie> = new Array();
    idProjektu: string;
}